var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-350 -95)"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M16.244 22.772c.657-1.098 1.623-1.66 2.904-1.676 1.281-.015 1.928-.667 1.949-1.951.018-1.278.574-2.244 1.672-2.898 1.101-.657 1.34-1.54.713-2.66-.624-1.116-.624-2.232 0-3.35.627-1.117.39-1.999-.713-2.656-1.098-.658-1.656-1.623-1.672-2.907-.021-1.278-.668-1.93-1.949-1.945-1.281-.018-2.247-.578-2.904-1.676-.657-1.1-1.54-1.34-2.656-.712-1.116.624-2.235.624-3.351 0-1.118-.626-2.001-.389-2.658.712-.656 1.1-1.623 1.66-2.903 1.676-1.278.015-1.927.667-1.945 1.945-.021 1.284-.578 2.247-1.676 2.907-1.101.657-1.342 1.538-.712 2.655.627 1.12.627 2.235 0 3.351-.63 1.12-.39 2.004.712 2.66 1.098.654 1.656 1.62 1.676 2.898.018 1.282.667 1.936 1.945 1.951 1.281.015 2.247.578 2.904 1.676.657 1.1 1.54 1.34 2.657.71 1.116-.619 2.235-.619 3.35 0 1.117.628 2.002.39 2.657-.71zm-4.329-3.85c-3.873 0-7.011-3.139-7.011-7.012 0-3.87 3.138-7.008 7.011-7.008 3.87 0 7.008 3.138 7.008 7.008 0 3.873-3.138 7.011-7.008 7.011z",
      "transform": "translate(350 95)"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.379 10.364L11.912 7.394 10.444 10.364 7.16 10.844 9.533 13.158 8.974 16.431 11.912 14.888 14.851 16.431 14.291 13.158 16.664 10.844z",
      "transform": "translate(350 95)"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }